export default [
  {
    path: '/workspace',
    name: 'workspace',
    component: () => import('@/views/workspace/Workspace.vue'),
    meta: {
      title: 'My Workspace',
      key: 'fullPath',
      requiresAuth: true,
      // No resource/action checks - access controlled by owner status in component
    },
  },
  {
    path: '/my-profile',
    name: 'my-profile',
    component: () => import('@/views/pages/profile/MyProfile.vue'),
    meta: {
      title: 'Profilku',
      key: 'fullPath',
      requiresAuth: true,
    },
  },
]
